import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { TooltippedIconButton } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import {
    getCategoryFloorResourcesCount,
    getResourceCountByCategory,
    getResourceCountByFloor,
} from '../../../selectors/resources';
import { openResourceForm as openResourceFormAction } from '../../../actions/steps';
import { ResourceGridCellWrapper } from './style';

interface EditResourceInterface {
    categoryId: string;
    floorId: string;
}

interface StateProps {
    resourcesPerFloor: number;
    totalResourcesPerCategory: number;
    totalResourcesPerFloor: number;
}

interface DispatchedActions {
    openResourceForm: ({ categoryId, floorId }: EditResourceInterface) => void;
}

interface OwnProps {
    floorId?: string;
    id?: string;
    isTotal?: boolean;
}

type ResourceGridCellProps = StateProps & OwnProps & DispatchedActions;

const ResourceGridCell = ({
    resourcesPerFloor,
    openResourceForm,
    id: categoryId,
    floorId,
    totalResourcesPerCategory,
    totalResourcesPerFloor,
    isTotal,
}: ResourceGridCellProps): JSX.Element => {
    const handleEditClick = () => categoryId && floorId && openResourceForm({ categoryId, floorId });

    const hasFloorResources = !!resourcesPerFloor;
    const totalCount = totalResourcesPerCategory || totalResourcesPerFloor;

    const gridCellContent = (
        <>
            {hasFloorResources ? resourcesPerFloor : UnicodeEntity.Dash}
            {UnicodeEntity.NoBreakSpace}
            <TooltippedIconButton
                tooltip={
                    <LocalizedText textKey={hasFloorResources ? TextKey.EditSpacePlural : TextKey.AddSpacePlural} />
                }
                icon={hasFloorResources ? IconName.Edit : IconName.Add}
                onClick={handleEditClick}
                size="small"
                variant="ghost"
                type="button"
            />
        </>
    );

    return <ResourceGridCellWrapper>{isTotal ? totalCount : gridCellContent}</ResourceGridCellWrapper>;
};

export default connect<StateProps, DispatchedActions, OwnProps, ApplicationState>(
    createStructuredSelector({
        resourcesPerFloor: getCategoryFloorResourcesCount,
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        totalResourcesPerCategory: getResourceCountByCategory,
        totalResourcesPerFloor: getResourceCountByFloor,
    }),
    {
        openResourceForm: openResourceFormAction,
    }
)(ResourceGridCell);
